import globalIP from '@/GlobelIP';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Breadcrumb,
  Button,
  Container,
  Divider,
  Input,
  Message,
  Panel,
  Stack,
  useToaster,
  Loader
} from 'rsuite';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { debounce } from 'lodash';
import { Paginator } from 'primereact/paginator';
import { setNestedObjectValues } from 'formik';
import { onMenuKeyDown } from 'rsuite/esm/Picker';
import { FaGalacticRepublic } from 'react-icons/fa';
import { getSafariVersion } from 'rsuite/esm/utils';
import ugr from '@/UGRoute';

interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
const EditCosting = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedItems = searchParams.get('selectedItems') || '';
  const selectedItemsArray = selectedItems.split(',');

  const [data, setData] = useState([
    {
      ProductName: '',
      ProductCode: '',
      ProductId: '',
      Description: '',
      MaterialName: '',
      AlluminiumWt: 0,
      ThermaPBL: 0,
      ThermaPBW: 0,
      ThermaPBH: 0,
      BaseCostTherma: 0,
      TPPL: 0,
      TPPW: 0,
      TPPH: 0,
      BaseCostPacking: 0,
      ThermaCost: 0,
      Part1L: 0,
      Part1W: 0,
      Part1H: 0,
      Part2L: 0,
      Part2W: 0,
      Part2H: 0,
      Part3L: 0,
      Part3W: 0,
      Part3H: 0,
      WoodCost: 0,
      WBanai: 0,
      WTCost: 0,
      WtenperCharge: 0,
      Wfiveperwastage: 0,
      WTCostWastage: 0,
      MetalWt: 0,
      Bata_Metal: 0,
      MetalCost: 0,
      MetalWastfiveper: 0,
      MetalWatCost: 0,
      GlassWeight: 0,
      GlassRate: 0,
      GlassTCost: 0,
      GlassFreight: 0,
      GlassTCRateFreight: 0,
      GlassWasteFivePer: 0,
      GlassTCWastage: 0,
      GlassTCFlower: 0,
      FinSize: '',
      FinRate: 0,
      FinTotal: 0,
      FinEachprPrice: 0,
      FinFivePerWaste: 0,
      FinNoOfBallUse: 0,
      FinTotalCost: 0,
      FinTotall: 0,
      LabNoOfDay: 0,
      LabCost: 0,
      LabWasteFivePer: 0,
      CCML: 0,
      CCMW: 0,
      CCMH: 0,
      CCMC: 0,
      MSI1I: '',
      MSI1L: 0,
      MSI1W: 0,
      MSI1H: 0,
      MSI1C: 0,
      MSI2I: '',
      MSI2L: 0,
      MSI2W: 0,
      MSI2H: 0,
      MSI2C: 0,
      MSINoCost: 0,
      MSITCostInner: 0,
      MSINofPvc: 0,
      MSINofPvcBox: 0,
      MSINofPvcBoxInner: 0,
      MSITCostInnerr: 0,
      CCPNoFPiece: 0,
      CCPCost: 0,
      CCPCBM: 0,
      FeltSize: '',
      FeltRate: 0,
      FeltCost: 0,
      PlateWeight: 0,
      PlateRate: 0,
      PlateCost: 0,
      PPNSize: '',
      PPNRate: 0,
      PPNCost: 0,
      PALength: 0,
      PARate: 0,
      PACost: 0,
      NikSize: '',
      NikRate: 0,
      NikCost: 0,
      CBNSize: '',
      CBNRate: 0,
      CBNCost: 0,
      Bubble: 0,
      LabForSheet: 0,
      TransCBM: 0,
      TransPPCBM: 0,
      TransCost: 0,
      TransCost_Overhead: 0,
      TotalwithMargin: 0,
      TotalPriceUSD: 0,
      TotalPriceUSD1: 0
    }
  ]);

  const [meta123, setMeta123] = useState<MetaData>();
  const [data123, setData123] = useState([]);
  const [data1234, setData1234] = useState([]);
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    const productvarid = selectedItemsArray.map(id => `filters[id][$eq]=${id}`).join('&');
    setProgress(30);
    setLoading(true);
    const response = await fetch(`${globalIP}/api/products?populate=*&pagination[page]=1`);
    setProgress(60);
    const json = await response.json();
    const allSelectedItems = [];
    const allSelectedItems1 = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/products?populate=*&pagination[page]=${page}`
      );
      const pageJson = await pageResponse.json();
      allSelectedItems1.push(...pageJson.data);
      // Accumulate selected items from this page
      const selectedItemsFromPage = pageJson.data.filter(item =>
        selectedItemsArray.includes(String(item.id))
      );
      allSelectedItems.push(...selectedItemsFromPage);
    }
    const responsevar = await fetch(`${globalIP}/api/variant-products?${productvarid}&populate=*`);
    const jsonvar = await responsevar.json();
    const newData1234 = [...allSelectedItems, ...jsonvar.data];
    setData123(allSelectedItems1);
    setMeta123(json.meta);
    setData1234(newData1234);
    setLoading(false);
    setProgress(100);
    const newData = newData1234.map(item => ({
      ProductName: item.attributes.ProductName || '',
      ProductCode: item.attributes.ProductCode || '',
      ProductId: item.attributes.ProductId || '',
      Description: item.attributes.Description || ''
    }));
    setData(newData);
  };
  const dataWithSerialNumbers = data1234
    .slice()
    .reverse()
    .map((item, index) => ({
      ...item,
      serialNumber: index + 1
    }));

  const onPageChange = event => {
    setCurrentPage(event.page);
    setRowsPerPage(event.rows);
  };

  const startIndex = currentPage * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedData = dataWithSerialNumbers.slice(startIndex, endIndex);

  const goto = useNavigate();
  const toaster = useToaster();
  const url = `${globalIP}/api/bulks-costings`;
  const submit1 = () => {
    toaster.push(
      <Message showIcon type="success">
        Saved Successfully.
      </Message>,
      { placement: 'topEnd' }
    );
    goto(`/${ugr}/bulk-costing`);
  };

  const submit = async e => {
    e.preventDefault();
    const hasEmptyMaterialName = data.some(product => !product.MaterialName.trim());
    if (hasEmptyMaterialName) {
      toaster.push(
        <Message showIcon type="error">
          Please Enter MaterialName
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      setLoading(true);
      try {
        for (const selectedProduct of data) {
          const formData = new FormData();
          formData.append('data', JSON.stringify({ ...selectedProduct }));

          const response = await fetch(url, {
            method: 'POST',
            body: formData
          });

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          const responseData = await response.json();
          console.log(responseData);
        }

        toaster.push(
          <Message showIcon type="success">
            Saved Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
      } catch (error) {
        console.error('Error:', error);
        toaster.push(
          <Message showIcon type="error">
            Error saving data. Please try again.
          </Message>,
          { placement: 'topCenter' }
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const [siii, setSiii] = useState([
    { label: 'CM', value: 'cm' },
    { label: 'Inch', value: 'inch' }
  ]);

  const debouncedUpdate = useCallback(
    debounce(updatedData => setData(updatedData), 300),
    []
  );

  const onInputChange = (value, rowIndex, field) => {
    const updatedData = [...data];
    updatedData[rowIndex][field] = value;
    debouncedUpdate(updatedData);
  };
  const inputTextBodyTemplate = (rowData, field, rowIndex, width) => {
    return (
      <Input
        value={rowData[field]}
        onChange={e => onInputChange(e, rowIndex, field)}
        style={{ width: width }}
      />
    );
  };

  const serialNumberBodyTemplate = (rowData, options) => {
    return <div style={{ width: '80px', textAlign: 'center' }}>{options.rowIndex + 1}</div>;
  };
  const imageBodyTemplate = rowData => {
    return (
      <div style={{ width: '80px', textAlign: 'center' }}>
        <img
          src={`${globalIP}${rowData.attributes.CoverImage.data.attributes.url}`}
          alt={rowData.ProductName}
          style={{ maxWidth: '100%', height: '5vh' }}
        />
      </div>
    );
  };
  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header="Sr. No." rowSpan={3} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Alias Code" rowSpan={3} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Image" rowSpan={3} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Product Name" rowSpan={3} style={{ border: '1px solid #d5d5d5' }} />
      </Row>
      <Row>
        <Column header="Size of Metal" colSpan={1} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Description" colSpan={1} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Alluminium Wgt." rowSpan={2} style={{ border: '1px solid #d5d5d5' }} />
        <Column
          header="Thermacol for Product Base"
          colSpan={3}
          style={{ border: '1px solid #d5d5d5' }}
        />
        <Column header="COST" colSpan={1} style={{ border: '1px solid #d5d5d5' }} />
        <Column
          header="Thermacol for Product Packing"
          colSpan={3}
          style={{ border: '1px solid #d5d5d5' }}
        />
        <Column header="BASE" colSpan={1} style={{ border: '1px solid #d5d5d5' }} />
        <Column
          header="Total Cost of Thermacol"
          rowSpan={2}
          style={{ border: '1px solid #d5d5d5' }}
        />
        <Column header="Part 1" colSpan={3} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Part 2" colSpan={3} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Part 3" colSpan={3} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Wood Costing" colSpan={6} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Metal Costing" colSpan={5} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Glass" colSpan={7} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Total Cost of FLOWER" rowSpan={2} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Finish" colSpan={7} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="TOTAL" rowSpan={2} style={{ border: '1px solid #d5d5d5' }} />
        <Column
          header="Labour at 135/day/labour"
          colSpan={3}
          style={{ border: '1px solid #d5d5d5' }}
        />
        <Column
          header="CARTON COSTING MASTER"
          colSpan={4}
          style={{ border: '1px solid #d5d5d5' }}
        />
        <Column
          header="MASTER SHEET COSTING INNER"
          colSpan={15}
          style={{ border: '1px solid #d5d5d5' }}
        />
        <Column header="TOTAL COST INNER +" rowSpan={2} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Carton cost per pc" colSpan={2} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="CBM" rowSpan={2} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="FELT" colSpan={3} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="PLATE" colSpan={3} style={{ border: '1px solid #d5d5d5' }} />
        <Column
          header="PLATE---POLISHING & NICLKLE"
          colSpan={3}
          style={{ border: '1px solid #d5d5d5' }}
        />
        <Column header="POLISH--alluminium" colSpan={3} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="NICLKLE" colSpan={3} style={{ border: '1px solid #d5d5d5' }} />
        <Column
          header="COPPER OR BLACK NICKLE"
          colSpan={3}
          style={{ border: '1px solid #d5d5d5' }}
        />
        <Column header="BUBBLE" rowSpan={2} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="WIRE" colSpan={1} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Transportation" colSpan={2} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="COST" rowSpan={2} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="COST +OVERHEAD" rowSpan={2} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="TOTAL" colSpan={2} style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Price USD 1" rowSpan={2} style={{ border: '1px solid #d5d5d5' }} />
      </Row>
      <Row>
        <Column header="Dimension" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Material Name" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Length" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Width" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Height" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="OF BASE THEMRACOL" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Length" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Width" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Height" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Cost OF PACKING" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Length" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Width" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Height" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Length" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Width" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Height" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Length" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Width" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Height" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Cost of Wood" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Banai" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Total Cost" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="10% CHARGE" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="WASTAGE 5%" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Total Cost with Wastage" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Wgt. of Metal" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="BATA + METAL" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Total Cost" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="WASTAGE 5%" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Total Cost with Wastage" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="WEIGHT" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="RATE" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="TOTAL COST" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="FREIGHT" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Total Cost RATE + Freight" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="WASTAGE 5%" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Total Cost with Wastage" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="SIZE" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="RATE" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="TOTAL" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="EACH PC PRICE" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="FLOWER 5% WASTAGE" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="NO. OF BALL USED" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Total Cost of Finish" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="No. of item/day" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Cost/Item" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="5% Wastage" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Length" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Width" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Height" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Cost" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Inch" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Length" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Width" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Height" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Cost" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Inch" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Length" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Width" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Height" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Cost" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="No. of INNERS" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="TOTAL COST OF INNER" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="TOTAL NO OF PVC/INNER" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="TOTAL NO OF PVC BOXES" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="TOTAL NO OF PVC BOXESK" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="NO of Piece / carton" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Cost / Item" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="SIZE" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="RATE" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="COST" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="WEIGHT ( GMS )" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="RATE" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="COST" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="SIZE" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="RATE" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="COST" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Length" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="RATE" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="COST" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="SIZE" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="RATE" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="COST" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="SIZE" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="RATE" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="COST" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="LABOR FOR SHEET" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="CBM@" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="PER PC CBM cost" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="with margin" style={{ border: '1px solid #d5d5d5' }} />
        <Column header="Price USD" style={{ border: '1px solid #d5d5d5' }} />
      </Row>
    </ColumnGroup>
  );
  return (
    <>
      <Container className="main">
        <Stack className="table-toolbar " justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start">
              <h3 className="title">Selected Products</h3>
              <Breadcrumb>
                <Breadcrumb.Item href={`/${ugr}/dashboard`}>Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Products</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
          </Stack>
          <Stack>
            <Button appearance="primary" color="cyan" onClick={submit} loading={loading}>
              Save
            </Button>
          </Stack>
        </Stack>
        <Divider className="divide" />
        {loading ? (
          <Loader center content="loading..." vertical />
        ) : (
          <>
            <Panel className="tab-pad" style={{ height: '55vh', overflowY: 'scroll' }}>
              <b>{data1234.length} Products</b>
              <DataTable
                value={paginatedData}
                headerColumnGroup={headerGroup}
                tableStyle={{ minWidth: '50rem', border: '1px solid #d5d5d5' }}
              >
                <Column
                  field="serialNumber"
                  header="Serial Number"
                  body={serialNumberBodyTemplate}
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="code"
                  header="Code"
                  body={rowData => (
                    <div style={{ width: '100px' }}>{rowData.attributes.ProductId}</div>
                  )}
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="ProductName"
                  header="Name"
                  body={imageBodyTemplate}
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="ProductName"
                  header="Name"
                  body={rowData => (
                    <div style={{ width: '120px' }}>{rowData.attributes.ProductName}</div>
                  )}
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="size"
                  header="Dimension"
                  body={rowData => (
                    <div style={{ width: '120px' }}>
                      {rowData.attributes.Length}x{rowData.attributes.Width}x
                      {rowData.attributes.Height} {rowData.attributes.SizeUnit}
                    </div>
                  )}
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="MaterialName"
                  header="MaterialName"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'MaterialName', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>

                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>

                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>

                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>

                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>

                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>

                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>

                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>

                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
                <Column
                  field="AlluminiumWt"
                  header="AlluminiumWt"
                  body={(rowData, options) =>
                    inputTextBodyTemplate(rowData, 'AlluminiumWt', options.rowIndex, '100px')
                  }
                  style={{ border: '1px solid #d5d5d5' }}
                ></Column>
              </DataTable>
              <Paginator
                first={currentPage * rowsPerPage}
                rows={rowsPerPage}
                totalRecords={dataWithSerialNumbers.length}
                onPageChange={onPageChange}
                template="PrevPageLink PageLinks NextPageLink"
              />
            </Panel>
          </>
        )}
        <Stack
          className="copyright"
          justifyContent="flex-end"
        spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERP Daddy Softwere Solution.
            </a>
          </p>
        </Stack>
      </Container>
    </>
  );
};

export default EditCosting;
